import { getLocaleValue } from '@/js/helper/locale.ts';
import Toastify from 'toastify-js';

type NotificationProps = {
  text?: string
  node?: HTMLElement
};

const DURATION = 3000;
export const ERROR_REQUEST_TEXT = getLocaleValue('failed_request');

export function showSuccessNotify(params: NotificationProps) {
  // eslint-disable-next-line ts/no-unsafe-call
  Toastify({
    text: params.text,
    node: params.node,
    duration: DURATION,
    close: true,
    className: 'notification notification_state_success',
    // eslint-disable-next-line ts/no-unsafe-member-access
  }).showToast();
}

export function showErrorNotify(params: NotificationProps) {
  // eslint-disable-next-line ts/no-unsafe-call
  Toastify({
    text: params.text,
    node: params.node,
    duration: DURATION,
    close: true,

    className: 'notification notification_state_error',
    // eslint-disable-next-line ts/no-unsafe-member-access
  }).showToast();
}

export function getNotificationElement(text: string, linkText: string, url: string) {
  const notifyElement = document.createElement('div');
  const linkElement = document.createElement('a');
  notifyElement.textContent = text;
  linkElement.textContent = linkText;
  linkElement.setAttribute('href', url);
  notifyElement.appendChild(linkElement);
  return notifyElement;
}
